const usableInputs = (access, selectedInputId = 'all') => {
  const available = [];
  access?.inputs?.forEach?.((input) => {
    if (!input || input.state === 'disconnected') return;
    available.push(input);
  });
  return selectedInputId === 'all'
    ? available
    : available.filter((input) => input.id === selectedInputId);
};

/**
 * Subscribe without claiming the device's single onmidimessage slot.
 * Explicitly opening each port matters for hardware that stays `pending`
 * until a Web MIDI client claims it (common with USB hubs and class-compliant
 * controllers on macOS).
 */
export function subscribeMidiInputs(access, onMessage, onInputsChanged = () => {}, options = {}) {
  const inputs = new Map();
  const selectedInputId = options.selectedInputId || 'all';
  const sync = () => {
    const available = usableInputs(access, selectedInputId);
    available.forEach((input) => {
      if (inputs.has(input)) return;
      Promise.resolve(input.open?.()).catch(() => {});
      input.addEventListener('midimessage', onMessage);
      inputs.set(input, onMessage);
    });
    inputs.forEach((handler, input) => {
      if (available.includes(input)) return;
      input.removeEventListener('midimessage', handler);
      inputs.delete(input);
    });
    const devices = [];
    access.inputs.forEach((input) => {
      if (!input || input.state === 'disconnected') return;
      devices.push({
        id: input.id,
        name: input.name || input.manufacturer || 'MIDI input',
        manufacturer: input.manufacturer || '',
        state: input.state || 'connected',
        connection: input.connection || 'pending'
      });
    });
    onInputsChanged(available.length, devices);
  };
  access.addEventListener('statechange', sync);
  sync();
  return () => {
    access.removeEventListener('statechange', sync);
    inputs.forEach((handler, input) => input.removeEventListener('midimessage', handler));
    inputs.clear();
  };
}
